<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.certificateNo"
              placeholder="请输入专卖证号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.storeName"
              placeholder="请输入店名"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <date-select :search-date.sync="masterList.tableQuery.search.searchDate" />
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @view="viewFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>
    <!-- 新增 修改-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 日期选择
import DateSelect from '@/components/DateSelect'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 新增 修改
import AddEditViewDialog from '@/views/terminalModule/tobaccoVisitList/components/addEditViewDialog'
// 数据请求
import { loadTobaccoVisitListListDataApi, loadTobaccoVisitListExportDataApi } from '@/api/tobaccoVisitList'
export default {
  name: 'TobaccoVisitListView',
  components: {
    CustomTable,
    DateSelect,
    TableOperation,
    AddEditViewDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'tobacco_visit_list_view_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['tobacco_visit_list_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['tobacco_visit_list_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            searchDate: '',
            certificateNo: '',
            storeName: ''
          }
        },
        notPaging: true
      },
      id: null, // 选中的单据ID
      dialogAddEditVisible: false,
      dialogAddEditTitle: '',
      eventType: ''
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'schemeNo', label: '方案编号', filterColumn: 'scheme_no', width: 200 },
      { prop: 'visitDateStr', label: '计划拜访日期', filterColumn: 'visit_date', width: 140 },
      { prop: 'visitUser', label: '走访人', filterColumn: 'visit_user', width: 100 },
      { prop: 'certificateNo', label: '专卖证号', filterColumn: 'certificate_no', width: 160 },
      { prop: 'customerNo', label: '客户编码', filterColumn: 'customer_no', width: 160 },
      { prop: 'benxiangNo', label: '本香门店码', filterColumn: 'benxiang_no', width: 160 },
      { prop: 'storeName', label: '店名', filterColumn: 'store_name', width: 160 },
      { prop: 'storeSortStr', label: '零售户类型', filterColumn: 'store_sort', filterValue: 'storeSort', width: 140, filterArray: [{ label: '重点', value: 1 }, { label: '潜力', value: 3 }, { label: '信息', value: 4 }] },
      { prop: 'provinceName', label: '所在省区', filterColumn: 'province_name', width: 120 },
      { prop: 'cityName', label: '所在城市', filterColumn: 'city_name', width: 120 },
      { prop: 'countyName', label: '所在区县', filterColumn: 'county_name', width: 120 },
      { prop: 'linkman', label: '联系人', filterColumn: 'linkman', width: 120 },
      { prop: 'phone', label: '联系电话', filterColumn: 'phone', width: 120 },
      { prop: 'address', label: '地址', filterColumn: 'address', width: 160 },
      { prop: 'signInTimeStr', label: '签到时间', filterColumn: 'sign_in_time', width: 160 },
      { prop: 'signOutTimeStr', label: '走访完成时间', filterColumn: 'sign_out_time', width: 160 },
      { prop: 'duration', label: '在店时长(分钟)', filterColumn: 'duration', width: 150 },
      { prop: 'level', label: '档位', filterColumn: 'level', width: 120 },
      { prop: 'regionStr', label: '城市/农村', filterColumn: 'region', width: 120, filterArray: [{ label: '城市', value: 'C' }, { label: '农村', value: 'X' }] },
      { prop: 'businessStr', label: '业态', filterColumn: 'business', width: 120, filterArray: [{ label: '食杂店', value: 'Z' }, { label: '便利店', value: 'B' }, { label: '超市', value: 'S' }, { label: '商场', value: 'N' }, { label: '烟酒店', value: 'Y' }, { label: '娱乐服务', value: 'F' }, { label: '其他', value: 'Q' }] },
      { prop: 'scaleStr', label: '规模', filterColumn: 'scale', width: 120, filterArray: [{ label: '大', value: 1 }, { label: '中', value: 2 }, { label: '小', value: 3 }] },
      { prop: 'tag', label: '标签', filterColumn: 'tag', width: 120 },
      { prop: 'matchResultStr', filterColumn: 'match_result', filterValue: 'matchResult', label: '匹配结果', width: 120, filterArray: [{ label: '匹配成功', value: 1 }, { label: '未匹配', value: 2 }, { label: '匹配失败', value: 3 }] },
      { prop: 'isCollectStr', filterColumn: 'is_collect', filterValue: 'isCollect', label: '动销采集', width: 120, filterArray: [{ label: '已采集', value: 1 }, { label: '', value: 2 }] },
      { prop: 'yunDisplayStatusStr', filterColumn: 'yun_display_status', filterValue: 'yunDisplayStatus', label: '云产卷烟陈列现状', width: 150, filterArray: [{ label: '有陈列', value: 1 }, { label: '无陈列', value: 2 }] },
      { prop: 'displayGridStr', filterColumn: 'display_grid', filterValue: 'displayGrid', label: '集中陈列格数', width: 130, filterArray: [{ label: '小于1格(背柜)', value: 1 }, { label: '1格(背柜)', value: 2 }, { label: '2格(背柜)', value: 3 }, { label: '3格(背柜)', value: 4 }, { label: '大于3格(背柜)', value: 5 }] },
      { prop: 'aiResult', label: 'AI识别结果', filterColumn: 'ai_result', width: 160 },
      { prop: 'auditStatusStr', filterColumn: 'audit_status', filterValue: 'auditStatus', label: '审核状态', width: 120, filterArray: [{ label: '未审核', value: 1 }, { label: '通过', value: 2 }, { label: '驳回', value: 3 }] },
      { prop: 'auditRemark', filterColumn: 'audit_remark', label: '审核意见', width: 180 },
      { prop: 'auditorName', filterColumn: 'auditor_name', label: '审核人', width: 120 },
      { prop: 'auditTimeStr', filterColumn: 'audit_time', label: '审核时间', width: 160, isBetween: true },
      { prop: 'isExecuteRejectStr', filterColumn: 'is_execute_reject', filterValue: 'isExecuteReject', label: '是否执行驳回', width: 140, filterArray: [{ label: '是', value: 1 }, { label: '否', value: 2 }] },
      { prop: 'executeUserName', filterColumn: 'execute_user_name', label: '执行人', width: 120 },
      { prop: 'executeTimeStr', filterColumn: 'execute_time', label: '执行时间', width: 160, isBetween: true },
      { prop: 'operatorName', filterColumn: 'operator_name', label: '操作人', width: 150 },
      { prop: 'operationTimeStr', filterColumn: 'operation_time', label: '操作时间', width: 160, isBetween: true }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadTobaccoVisitListListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'view'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
      this.dialogAddEditTitle = '查看中烟走访记录'
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadTobaccoVisitListExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
